import { Controller } from "@hotwired/stimulus"
import { clearForm } from "../helpers"

// zarzadzanie warunkiem transakcji
export default class extends Controller {
  static targets = ["destroy"]
  static values = { removeOnClear: { type: Boolean, default: false } }

  remove() {
    const container = this.element.parentElement
    const subsection = this.element.dataset.transactionTermsSubsection

    if (this.hasDestroyTarget) {
      this.destroyTarget.value = "1"
      this.element.hidden = true
    } else if (this.removeOnClearValue) {
      this.element.remove()
    } else {
      clearForm(this.element, { resetSelectToFirst: true })
    }

    this.dispatch("removed", { target: container, detail: { subsection } })
  }
}
